import { requestJson, assertOk} from "./storeApi"

export async function saveProductAttributes(productId, attributes) {
	const { response, payload } = await requestJson(`/products/${productId}/attributes`, {
		method: "PUT",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ attributes }),
	});
	if (response.status === 204) return true;
	return assertOk(response, payload, "Failed to save attributes");
}

export async function getProducts() {
    const { response, payload } = await requestJson("/products", {
        method: "GET",
    });

    return assertOk(response, payload, "Failed to load products");
}

export async function getProduct(productId) {
    const { response, payload } = await requestJson(`/products/${productId}`, {
        method: "GET",
    });

    return assertOk(response, payload, "Failed to load product");
}



export async function createProduct(product) {
	const { response, payload } = await requestJson("/products", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(product),
	});

	return assertOk(response, payload, "Failed to create product");
}

// i did this and i am mike. i almost wanted to say that i was the wolverine but i cant do that. im not that legendary. 
export async function addProductAttributes(productId, attributes) {
	const normalizedAttributes = Array.isArray(attributes) ? attributes : [];
	const { response, payload } = await requestJson(`/products/${productId}/attributes`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ attributes: normalizedAttributes }),
	});

	return assertOk(response, payload, "Failed to add product attributes");
}

export async function updateProductAttributeValue(productId, attributeId, attributeValue) {
	const normalizedProductId = Number(productId || 0);
	const normalizedAttributeId = Number(attributeId || 0);
	const normalizedValueId = Number(attributeValue?.id ?? attributeValue?.value_id ?? 0);

	if (!Number.isFinite(normalizedProductId) || normalizedProductId <= 0 || !Number.isFinite(normalizedAttributeId) || normalizedAttributeId <= 0) {
		throw new Error("A valid product and attribute id are required.");
	}

	// This route only updates an existing row; new values must go through addProductAttributes.
	if (!Number.isFinite(normalizedValueId) || normalizedValueId <= 0) {
		throw new Error("A valid attribute value id is required to update a value.");
	}

	const valuePayload = {
		attribute_id: normalizedAttributeId,
		value_id: normalizedValueId,
		value: String(attributeValue?.value ?? "").trim(),
		duration: Number(attributeValue?.duration ?? 0) || 0,
		price: Number(attributeValue?.price ?? 0) || 0,
	};

	const { response, payload } = await requestJson(`/products/${normalizedProductId}/attributes/${normalizedAttributeId}`, {
		method: "PUT",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(valuePayload),
	});

	return assertOk(response, payload, "Failed to update attribute value");
}

export async function deleteProductAttribute(productId, attributeId) {
	const normalizedProductId = Number(productId);
	const normalizedAttributeId = Number(attributeId);

	if (!Number.isSafeInteger(normalizedProductId) || normalizedProductId <= 0
		|| !Number.isSafeInteger(normalizedAttributeId) || normalizedAttributeId <= 0) {
		throw new Error("A valid product and attribute id are required.");
	}

	const { response, payload } = await requestJson(
		`/products/${normalizedProductId}/attributes/${normalizedAttributeId}`,
		{ method: "DELETE" }
	);

	if (response.status === 204) {
		return true;
	}

	return assertOk(response, payload, "Failed to delete attribute group");
}

export async function deleteProductAttributeValue(productId, attributeId, valueId) {
	const normalizedProductId = Number(productId || 0);
	const normalizedAttributeId = Number(attributeId || 0);
	const normalizedValueId = Number(valueId || 0);

	if (
		!Number.isFinite(normalizedProductId) || normalizedProductId <= 0
		|| !Number.isFinite(normalizedAttributeId) || normalizedAttributeId <= 0
		|| !Number.isFinite(normalizedValueId) || normalizedValueId <= 0
	) {
		throw new Error("A valid product, attribute and value id are required.");
	}

	const { response, payload } = await requestJson(
		`/products/${normalizedProductId}/attributes/${normalizedAttributeId}/values/${normalizedValueId}`,
		{ method: "DELETE" }
	);

	if (response.status === 204) {
		return true;
	}

	return assertOk(response, payload, "Failed to delete attribute value");
}



export async function updateProductDetails(productId, details) {
	const { response, payload } = await requestJson(`/products/${productId}`, {
		method: "PUT",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(details),
	});

	if (response.status === 204) {
		return true;
	}

	return assertOk(response, payload, "Failed to update product");
}

export async function deleteProduct(productId) {
	const { response, payload } = await requestJson(`/products/${productId}`, {
		method: "DELETE",
	});

	return assertOk(response, payload, "Failed to delete product");
}








export async function uploadProductImage(productId, imageFile, options = {}) {
	const normalizedProductId = Number(productId);
	if (!Number.isFinite(normalizedProductId) || normalizedProductId <= 0) {
		throw new Error("A valid product id is required to upload an image.");
	}

	if (!(imageFile instanceof File)) {
		throw new Error("A valid image file is required.");
	}

	const formData = new FormData();
	formData.append("image", imageFile);

	const altText = String(options?.altText || "").trim();
	if (altText) {
		formData.append("alt_text", altText);
	}

	const { response, payload } = await requestJson(`/products/${normalizedProductId}/images`, {
		method: "POST",
		body: formData,
	});

	return assertOk(response, payload, "Failed to upload product image");
}

export async function deleteProductImage(productId, imageId) {
	const normalizedProductId = Number(productId);
	const normalizedImageId = Number(imageId);

	if (!Number.isFinite(normalizedProductId) || normalizedProductId <= 0
		|| !Number.isFinite(normalizedImageId) || normalizedImageId <= 0) {
		throw new Error("A valid product and image id are required.");
	}

	const { response, payload } = await requestJson(`/products/${normalizedProductId}/images/${normalizedImageId}`, {
		method: "DELETE",
	});

	if (response.status === 204) {
		return true;
	}

	return assertOk(response, payload, "Failed to delete product image");
}


export async function updateAttributeQueue(productId, attributes) {
	const normalizedProductId = Number(productId);
	if (!Number.isFinite(normalizedProductId) || normalizedProductId <= 0) {
		throw new Error("A valid product id is required to update attribute queue.");
	}

	if (!Array.isArray(attributes) || attributes.length === 0) {
		throw new Error("At least one attribute is required to update attribute queue.");
	}

	const { response, payload } = await requestJson(`/products/attributes/queue/${normalizedProductId}`, {
		method: "PUT",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ attributes }),
	});

	if (response.status === 204) {
		return true;
	}

	return assertOk(response, payload, "Failed to update attribute queue");
}

export async function addAttributeIncompatibility(productId, attributeValueId, incompatibleWithIds) {
	const normalizedProductId = Number(productId);
	const normalizedAttributeValueId = Number(attributeValueId);
	const normalizedIncompatibleWithIds = Array.isArray(incompatibleWithIds) ? incompatibleWithIds.map(Number) : [];

	if (!Number.isFinite(normalizedProductId) || normalizedProductId <= 0
		|| !Number.isFinite(normalizedAttributeValueId) || normalizedAttributeValueId <= 0
		|| normalizedIncompatibleWithIds.length === 0
		|| normalizedIncompatibleWithIds.some(id => !Number.isFinite(id) || id <= 0)) {
		throw new Error("A valid product id, attribute value id, and incompatible with ids are required.");
	}

	const { response, payload } = await requestJson(`/products/attributes/incompatibilities/${normalizedProductId}`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			attribute_value_id: normalizedAttributeValueId,
			incompatible_with_id: normalizedIncompatibleWithIds,
		}),
	});

	if (response.status === 204) {
		return true;
	}

	return assertOk(response, payload, "Failed to add attribute incompatibility");
}

async function requestCompatibilityRules(productId, suffix, options) {
	if (!Number.isSafeInteger(Number(productId)) || Number(productId) <= 0) {
		throw new Error("A valid service id is required.");
	}
	const { response, payload } = await requestJson(`/products/${productId}/incompatibilities${suffix}`, options);
	const result = assertOk(response, payload, "Failed to manage incompatibilities");
	if (!Array.isArray(result?.rules)) {
		throw new Error("The server returned an invalid incompatibility list.");
	}
	return result.rules;
}

export function getCompatibilityRules(productId) {
	return requestCompatibilityRules(productId, "", { method: "GET" });
}

export function createCompatibilityRules(productId, selections) {
	return requestCompatibilityRules(productId, "", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(selections),
	});
}

export function deleteCompatibilityRule(productId, rule) {
	if (!Number.isSafeInteger(Number(rule?.id)) || Number(rule.id) <= 0) {
		throw new Error("A valid incompatibility rule is required.");
	}
	return requestCompatibilityRules(productId, `/${rule.id}?legacy=${Boolean(rule.legacy)}`, { method: "DELETE" });
}